import { create } from "zustand";

interface JobOrderState {
  jobOrderData: any;
  setJobOrderData: (data: any) => void;
}

interface AppState {
  refetchNeeded: boolean;
  setRefetchNeeded: (needed: boolean) => void;
}

interface WorkspaceState {
  workspace: any;
  setWorkspace: (workspace: any) => void;
}
export const useJobOrderStore = create<JobOrderState>((set) => ({
  jobOrderData: null,
  setJobOrderData: (data) => set({ jobOrderData: data }),
}));

export const useAppState = create<AppState>((set) => ({
  refetchNeeded: false,
  setRefetchNeeded: (needed) => set({ refetchNeeded: needed }),
}));

export const useWorkSpaceStore = create<WorkspaceState>((set) => ({
  workspace: JSON.parse(localStorage.getItem("workspace") || "{}"),
  setWorkspace: (workspace) => {
    const formattedWorkspace = JSON.stringify(workspace);

    localStorage.setItem("workspace", formattedWorkspace);
    set({ workspace });
  },
}));

export const useRefetchStore = create<{
  refetch: any;
  setRefetch: (refetch: any) => void;
}>((set) => ({
  refetch: null,
  setRefetch: (refetch) => set({ refetch }),
}));
